import React, { useState, useEffect, useRef } from 'react'
import { DeleteFilled, EditFilled, EditOutlined, ExportOutlined, FilterOutlined, InfoCircleOutlined, NumberOutlined, PlusCircleFilled, PlusCircleOutlined, SendOutlined } from '@ant-design/icons';
import { Button, Flex, Table, Tooltip, Typography, Row, Col, Input, Divider, DatePicker, Modal, Descriptions, Tag, Card } from 'antd'
import { useSelector } from 'react-redux';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import AuthService from '../../Components/auth/AuthService';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@mui/material';
import { showMessage } from '../../Components/Utils/message';
import { DownloadTwoTone } from '@mui/icons-material';
import { locationTypes } from '../../Components/common/Constants';
import ScanSelect from "../Scan/ScanSelect";
import ProductScanSelect from "../Scan/ProductScanSelect";
import { encodeId, formatBatchCode } from "../../Components/common/CommonFun";
import dayjs from "dayjs";
import DetailsGrid from '../../Components/common/DetailsGrid';
import { styled } from '@mui/system';
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;
const Auth = new AuthService();
const TransactionsOpeningBalanceList = () => {
  const { type, roles, aisles, locations, products } = useSelector((state) => state?.AppState?.userCreds);
  const canSeePost =
    type === 0 ||
    type === 1 ||
    (type === 2 && roles?.some((role) => role.role_id === 4));
  const navigate = useNavigate();
  const { Text } = Typography;
  const layoutDispatch = useLoadingDispatch()
  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [itemDetails, setItemDetails] = useState({
    product: "",
    product_id: null,
    location_id: null,
    quantity: "",
    productText: '',
    productStatus: null,
    expiry_date: null,
    batch_code: "",
    supplier_batch_code: "",
  });

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [batchTransactions, setBatchTransactions] = useState([]);

  const [selectedLocations, setSelectedLocations] = useState([])

  const productRef = useRef(null);
  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        productRef.current?.focus();
      }, 100);
    }
  }, [modalVisible]);

  const handleSelect = async (record) => {
    // setSelectedItem(record);
    // setModalVisible(true)
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ob/stock-batches?opening_balance_id=${record?.id}`);
      if (res?.ack) {
        const totalQuantityAdded = res?.stock_batches.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
        const currentItemBatchId = res?.stock_batches[0]?.opening_balance_id;
        const updatedRemainingQty = record?.quantity - totalQuantityAdded;
        const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
        const updatedReceivedData = data.map(item => {
          if (item.id === currentItemBatchId) {
            return { ...item, remaining_quantity: updatedRemainingQty, batch_quantity: totalQuantityAdded };
          }
          return item;
        });
        setSelectedItem(updatedRecord);
        setData(updatedReceivedData)

        setBatchTransactions(res?.stock_batches || []);
        const hasLocations = await getLocations();
        if (hasLocations) {
          setModalVisible(true);
        } else {
          showMessage("error", "No locations available");
        }
      } else {
        showMessage('error', res?.message);
        setBatchTransactions([]);
      }
    } catch (error) {
      console.error("Error fetching stock batches:", error);
      showMessage('error', "Something went wrong while fetching stock batches");
      return;
    } finally {
      hideLoading(layoutDispatch);
    }

  };

  const deleteTransaction = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ob/new-stock`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        setModalVisible(false);
        getTransactionData();
      } else {
        showMessage('error', res?.message);
        // handleSearch();
        hideLoading(layoutDispatch);

      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    }
  };

  const deleteOpeningBalance = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ob/opening-balance`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success', res?.message);
        getTransactionData();
      } else {
        showMessage('error', res?.message);
        hideLoading(layoutDispatch);

      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
      hideLoading(layoutDispatch);
    }
  };


  const dataCol = [
    {
      title: "Sr No.",
      render: (_, __, index) => <span>{index + 1}</span>,
      width: 60,
    },
    {
      title: 'Product',
      render: (record) => {
        const productitem = products?.find((item) => item.netsuite_id === record.product_netsuite_id)
        return (
          <span>{productitem ? `${productitem.code} - ${productitem?.name}` : record.product_netsuite_id}</span>
        );
      }
    },


    {
      title: "Category",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);

        return (
          <span>{item ? `${item?.sub_category}` : '-'}</span>
        )

      }
    },
    {
      title: "Status",
      render(record) {
        return (
          <Tag color={record?.posted_by > 0 ? 'green' : 'warning'}>{record?.posted_by > 0 ? `Posted` : 'Pending'}</Tag>
        )

      }
    },
    {
      title: "Quantity",
      render: (record) => {
        return <span>{record?.quantity?.toLocaleString() || '0'}</span>;
      },
      align: 'center',
    },
    {
      title: "Added Qty",
      render: (record) => {
        return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.added_quantity ? record?.added_quantity?.toLocaleString() : '0'} </Tag>;
      },
      align: 'center',
    },
    {
      title: "Remaining Qty",
      render: (record) => {
        return <Tag color={record?.remaining_quantity > 0 ? 'error' : 'blue'} style={{ fontSize: 16, fontWeight: 'bold' }}>{record?.remaining_quantity ? record?.remaining_quantity?.toLocaleString() : '0'} </Tag>;
      },
      align: 'center',
    },
    {
      title: "Action",
      align: "right",
      render: (record) => (

        <Flex justify='end' gap={8}>
          
              <Tooltip title='Edit Item'>
                <EditFilled onClick={() => {
                  const hasedID = encodeId(record?.id)

                  navigate(`/transaction-ob/${hasedID}`)
                }} style={{ fontSize: '25px', cursor: "pointer", color: "#006cb8" }} />
              </Tooltip>
            
          <Tooltip title="Select Item">
            <ExportOutlined
              className="animated-select-icon"
              onClick={() => handleSelect(record)}
            />
          </Tooltip>
          {
            !record?.posted_by > 0 && (
              <Tooltip title='Delete'>
                <DeleteFilled
                  style={{
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                  }}
                  onClick={() => {
                    Modal.confirm({
                      title: 'Delete Opening Balance',
                      centered: true,
                      content: `Are you sure to delete this opening balance entery?`,
                      onOk: () => deleteOpeningBalance(record.id),
                      okText: 'Delete',
                      cancelText: 'Cancel',
                      width: 600,
                      okButtonProps: { size: "large" },
                      cancelButtonProps: { size: "large" },
                    });
                  }}
                />
              </Tooltip>
            )
          }

        </Flex>
      ),
    }

  ];

  const batchCol = [

    {
      title: "Batch Code",
      dataIndex: 'batch_code',
      key: 'batch_code',
    },
    
    {
      title: "Supplier Batch Code",
      dataIndex: 'supplier_batch_code',
      key: 'supplier_batch_code',
    },
    {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },

    {
          title: 'Location',
          render: (record) => {
            const selected = locations?.find((item) => item.id == record?.location_id)
            return (
              <>
                {selected?.code || ""}
              </>
            );
          },
          width: 80
    
        },

    {
      title: "Quantity",
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity) => {
        return <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(quantity)?.toLocaleString() || 0} </Tag>;
      },
      align: 'center',
    },
    {
      title: "User",
      render(record) {
        if (!record) return "";

        const user = record?.user_name || "";
        const helper = record?.helper_name || "";

        if (helper) {
          return (
            <>
              {helper}{" "}
              {user && (
                <Tooltip title={`${user}`}>
                  <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
                </Tooltip>
              )}
            </>
          );
        }

        return <>{user}</>;
      }
    },
    // {
    //   title: 'Action',
    //   align: "right",
    //   dataIndex: '',
    //   render(record) {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "flex-end" }}>
    //         <DeleteFilled
    //           style={{
    //             fontSize: "25px",
    //             cursor: "pointer",
    //             color: "#cd1437",
    //           }}
    //           onClick={() => {
    //             Modal.confirm({
    //               title: 'Delete Transaction',
    //               centered: true,
    //               content: `Are you sure to delete this transaction?`,
    //               onOk: () => deleteTransaction(record.id),
    //               okText: 'Delete',
    //               cancelText: 'Cancel',
    //               width: 600,
    //               okButtonProps: { size: "large" },
    //               cancelButtonProps: { size: "large" },
    //             });
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // }
  ];

  if (!selectedItem?.posted_by > 0) {
    batchCol.push({
      title: 'Action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DeleteFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                color: "#cd1437",
              }}
              onClick={() => {
                Modal.confirm({
                  title: 'Delete Transaction',
                  centered: true,
                  content: `Are you sure to delete this transaction?`,
                  onOk: () => deleteTransaction(record?.purchase_order_details_batch_id),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            />
          </div>
        );
      },
    })
  }


  const getTransactionData = async (download) => {
    if (!download) setData([]);
    showLoading(layoutDispatch);
    const dataToSend = {};
    if (download) {
      dataToSend.download = 1;
    }
    try {
      const res = await Auth.post(`/ob/opening-balances`, dataToSend);
      if (res.ack) {
        if (download) {
          window.open(res.file_url, "_blank", "noreferrer");
        } else {
          const items = res?.opening_balances ?? [];
          const updatedItems = items.map(item => ({
            ...item,
            batch_code: item.batch_code || '',
            expiry_date: null,
            remaining_quantity: item?.quantity - Number(item.added_quantity),
          }));
          setData(updatedItems);
          setTotalPages(Math.ceil(res.total_count / limit));
          setTotalCount(res.total_count);
        }

      } else {
        showMessage('error', res.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  useEffect(() => {
    getTransactionData()

  }, []);

  const postOB = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.post(`/ob/post-opening-balance`, {});
      if (res.ack) {
        showMessage('success', res.message);
        getTransactionData();
      } else {
        showMessage('error', res.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong while posting opening balances.');
    } finally {
      hideLoading(layoutDispatch);
    };
  }

  const productSelectValueChange = (val, isScanned) => {

    const selectedProduct = isScanned
      ? products?.find((pro) => pro?.code === val || pro?.barcode === val)
      : products?.find((pro) => pro?.netsuite_id === val);

    const matchedProduct = selectedItem?.product_netsuite_id === selectedProduct?.netsuite_id;

    if (selectedProduct && matchedProduct) {
      const dateFromNowToNextYear = dayjs().add(1, 'year')
      const DateFormat = dayjs(dateFromNowToNextYear).format('DD-MM-YYYY');
      const documentNumber = 'OB';
      const batchCode = formatBatchCode(documentNumber, DateFormat, selectedProduct?.code);
      const firstCharacter = selectedProduct?.code?.charAt(0);
      if (firstCharacter != 'C') {
        setItemDetails({
          ...itemDetails,
          product_id: selectedProduct?.netsuite_id,
          productStatus: 'success',
          productText: selectedProduct?.name,
          batch_code: batchCode,
          expiry_date: dayjs(dateFromNowToNextYear, 'YYYY-MM-DD')
        });

      } else {

        setItemDetails({
          ...itemDetails,
          product_id: selectedProduct?.netsuite_id,
          productStatus: 'success',
          productText: selectedProduct?.name,
          batch_code: null,
          expiry_date: null
        });
      }

    } else {
      setItemDetails({
        ...itemDetails,
        productStatus: 'error',
        productText: 'Invalid Product',
        batch_code: '',
        product: '',
        product_id: ''
      })
      showMessage('error', 'Invalid Product Selected');
    }
  };

  const locationSelectValueChange = (val, isScanned) => {
    console.log('locationSelectValueChange', val, isScanned);
    if (!itemDetails?.product_id) {
      showMessage('error', 'Please select a product first')
      setItemDetails({ ...itemDetails, location_id: null })
      return;
    }
    if (isScanned) {
      const matched = locations?.find(item => item.code === val);
      if (matched) {
        setItemDetails({ ...itemDetails, location_id: matched.id });
      } else {
        showMessage('error', "No matching location");
      }
    } else {
      setItemDetails({ ...itemDetails, location_id: val });
    }
  };

  const handleModalCancel = () => {
    setSelectedItem(null);
    setItemDetails({ product: "", product_id: '', quantity: "", productText: '', productStatus: null, expiry_date: null, remaining_quantity_check: false })
    setModalVisible(false);
  };

  const handleModalOk = async () => {
    if (!itemDetails?.product_id || !itemDetails?.location_id || !itemDetails?.quantity || !itemDetails?.expiry_date || !itemDetails?.supplier_batch_code) {
      showMessage('error', "Please fill all the required fields.");
      return;
    }
    if (Number(itemDetails?.quantity) <= 0) return showMessage('error', "Quantity must be greater than zero.");
    const dataToSend = {
      transaction_id: selectedItem?.id,
      quantity: itemDetails?.quantity,
      expiry_date: itemDetails?.expiry_date ? dayjs(itemDetails?.expiry_date).format("YYYY-MM-DD") : '',
      batch_code: itemDetails?.batch_code,
      supplier_batch_code: itemDetails?.supplier_batch_code,
      product_netsuite_id: itemDetails?.product_id,
      location_id: itemDetails?.location_id
    }
    showLoading(layoutDispatch);
    // try {
    //   const res = await Auth.fetch("/ob/add-new-stock", {
    //     method: "POST",
    //     body: JSON.stringify(dataToSend)
    //   });
    //   if (res?.ack) {
    //     showMessage('success', res?.message);
    //     setModalVisible(false);
    //     setData(prevItems =>
    //       prevItems.map(item => {
    //         if (item.product_netsuite_id === selectedItem.product_netsuite_id) {
    //           const currentQty = Number(item.added_quantity) || 0;
    //           const newQty = currentQty + Number(itemDetails.quantity);
    //           const newRem = selectedItem?.remaining_quantity - Number(itemDetails?.quantity)
    //           return { ...item, added_quantity: newQty, remaining_quantity: newRem };
    //         }
    //         return item;
    //       })
    //     );
    //     setItemDetails({ product: "", product_id: null, location_id: null, quantity: "", productText: '', productStatus: null, expiry_date: null, batch_code: '', supplier_batch_code: '', remaining_quantity_check: false });
    //     setSelectedItem(null);
    //   } else {
    //     showMessage('error', res?.message);
    //     hideLoading(layoutDispatch);
    //   }
    // } catch (error) {
    //   console.error("Error saving item details:", error);
    //   showMessage('error', "Something went wrong while saving item details");
    //   // hideLoading(layoutDispatch);
    // } finally {
    //   hideLoading(layoutDispatch)
    // }

    const submitStock = async (payload) => {
      showLoading(layoutDispatch);
      try {
        const res = await Auth.fetch("/ob/add-new-stock", {
          method: "POST",
          body: JSON.stringify(payload)
        });

        if (res?.ack) {
          setModalVisible(false);
          setData(prevItems =>
            prevItems.map(item => {
              if (item.product_netsuite_id === selectedItem.product_netsuite_id) {
                const currentQty = Number(item.added_quantity) || 0;
                const newQty = currentQty + Number(itemDetails.quantity);
                const newRem = selectedItem?.remaining_quantity - Number(itemDetails?.quantity)
                return { ...item, added_quantity: newQty, remaining_quantity: newRem };
              }
              return item;
            })
          );
          setItemDetails({ product: "", product_id: null, location_id: null, quantity: "", productText: '', productStatus: null, expiry_date: null, batch_code: '', supplier_batch_code: '', remaining_quantity_check: false });
          setSelectedItem(null);
        } else {
          showMessage('error', res?.message);
          hideLoading(layoutDispatch);

          if (res?.capacity_increased_by) {
            const cases_in_pallets = products?.find(pro => pro?.netsuite_id == itemDetails?.product_id)?.cases_in_pallets || 0;
            const capcityCal = res?.capacity_increased_by * cases_in_pallets;
            const plusSignWithCapcity = capcityCal < 0 ? `${Math.abs(capcityCal)}` : capcityCal;
            if (plusSignWithCapcity >= cases_in_pallets) return showMessage('error', 'Please select another location, this location capacity is full');
            Modal.confirm({
              title: "Capacity Exceeded",
              content: (
                <div style={{ fontSize: 16 }}>
                  Location capacity exceeded by{" "}
                  <span style={{ color: "green", fontWeight: "bold", fontSize: 18 }}>
                    {Number(plusSignWithCapcity)?.toFixed(2)}
                  </span>{" "}
                  cases. Do you want to receive the stock anyway?
                </div>
              ),
              okText: "Yes",
              cancelText: 'Cancel',
              width: 600,
              okButtonProps: { size: "large" },
              cancelButtonProps: { size: "large" },
              onOk: () => submitStock({ ...payload, bypass_capacity_check: true })
            });
          }
        }
      } catch (err) {
        console.log(err);
        showMessage('error', 'Something went wrong');
      } finally {
        hideLoading(layoutDispatch);
      }
    };

    // First API call
    submitStock(dataToSend);
  }

  const getLocations = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/location/locations`);
      if (res?.ack) {
        console.log(res?.locations, 'locations');
        setSelectedLocations(res?.locations)
        return true;
      } else {
        showMessage('err', res?.message)
        setSelectedLocations([])
        return false;
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const remainQtyCheck = data
    ?.filter(item => item?.posted_by == null || item?.posted_by < 1)
    ?.every(item => item?.remaining_quantity < 1);

  const infoItem = [
    { label: 'Total Quantity', value: selectedItem?.quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: '#1677ff' },
    { label: 'Remaining Quantity', value: selectedItem?.remaining_quantity?.toLocaleString() || '0', type: 'text', icon: <NumberOutlined style={{ color: "#1677ff" }} />, color: selectedItem?.remaining_quantity > 0 ? 'red' : '#1677ff' },
  ]

  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff' }} /> Opening Balance</>}
        style={{ marginBottom: '10px' }}
        bodyStyle={{ display: 'none'}}
        extra={
          <>
            <Flex gap={10}>
              {
                data?.length > 0 && (
                  <>
                    <Button type='primary' icon={<DownloadTwoTone />} onClick={() => { getTransactionData(1) }}>Download</Button>
                    {
                      canSeePost && (
                        <>
                          {
                            remainQtyCheck ? (
                              <Button type='primary' icon={<SendOutlined />}
                                onClick={() => {
                                  Modal.confirm({
                                    title: 'Post Opening Balances',
                                    centered: true,
                                    content: `Are you sure to post opening balances?`,
                                    onOk: () => postOB(),
                                    okText: 'Post',
                                    cancelText: 'Cancel',
                                    width: 600,
                                    okButtonProps: { size: "large" },
                                    cancelButtonProps: { size: "large" },
                                  });
                                }}
                              >POST</Button>
                            ) : (
                              <Button type='primary' icon={<SendOutlined />}
                                onClick={() => {
                                  showMessage('error', 'Can not post! Some items still have remaining quantities to be added')
                                }}
                              >POST</Button>
                            )
                          }
                        </>

                      )
                    }

                  </>
                )
              }
              <PlusCircleFilled style={{ fontSize: "30px", color: "#1677FF", marginBottom: '5px' }} onClick={() => navigate('/transaction-ob/new')} />

            </Flex>
          </>
        }
      />


      <Table
        columns={dataCol}
        style={{ marginTop: "10px" }}
        scroll={{ x: 'max-content' }}
        dataSource={data}
        pagination={false}
        footer={() => {
          return `Total Records: ${data?.length ? data.length : "0"}`;

        }}
        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
      />

      <Modal width={'75vw'}
        //  title={`${'Item Details'}`}
        title={
          (() => {
            const product = products?.find(p => p.netsuite_id === selectedItem?.product_netsuite_id);
            return product ? `Opening Balances: ${product.code} - ${product.name}` : 'Item Details';
          })()
        }
        open={modalVisible}
        // onOk={handleModalOk} 
        onCancel={handleModalCancel}
        //  okText="Save"
        okButtonProps={{ disabled: !itemDetails?.product_id, style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: selectedItem?.remaining_quantity > 0 && 'none' } }}
        bodyStyle={{ paddingRight: 6 }}
        style={{ top: 40 }}
      >
        <Divider style={{ margin: '5px 0px' }} />

        <>
          {(selectedItem?.remaining_quantity) > 0 && (

            <DetailsGrid infoItems={infoItem} />
          )}
          <>
            {
              (selectedItem?.remaining_quantity) > 0 && (
                <>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Text>Product<span style={{ color: 'red' }}>*</span></Text>
                      <ProductScanSelect
                        onValueChange={productSelectValueChange}
                        value={itemDetails?.product_id}
                        options={products} placeholder="Product"
                        size="large"
                        length={'100%'}
                        productRef={productRef}
                      />
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Text>Location<span style={{ color: 'red' }}>*</span></Text>
                      <ScanSelect onValueChange={locationSelectValueChange} value={itemDetails?.location_id} options={selectedLocations} placeholder="Location" size="large" length={'100%'} capacityCheck={true} />
                    </Col>
                  </Row>
                  <Row  >
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                      <Text>Quantity<span style={{ color: 'red' }}>*</span></Text>
                      {/* <Flex align="center" gap="small"> */}
                      <Input size="large" type='number' value={itemDetails?.quantity}
                        onChange={(e) => {
                          if (!itemDetails?.product_id) {
                            setItemDetails({ ...itemDetails, productStatus: 'error', productText: 'Please select a product first' })
                            showMessage('error', 'Please select a product first');
                            return;
                          }
                          // const newQty = e.target.value
                          const raw = e.target.value;
                          const newQty = /^\d*$/.test(raw) ? raw.replace(/^0+(?=\d)/, "") : '1';
                          // if (newQty < 0) {
                          //   showMessage('error', 'Quantity cannot be negative');
                          //   return;
                          // }
                          if (newQty > selectedItem?.remaining_quantity) {
                            showMessage('error', `Quantity cannot be greater than ${selectedItem?.remaining_quantity}`);
                            return;
                          } else {
                            setItemDetails({ ...itemDetails, quantity: newQty })
                          }
                        }
                        }
                        // style={{ width: "290px" }} 
                        placeholder="Quantity" />
                      {/* </Flex> */}
                    </Col>

                  </Row>

                  <Row >
                    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                      <Text>Supplier Batch Code<span style={{ color: 'red' }}>*</span></Text>
                      <br />
                      <Input size="large" value={itemDetails?.supplier_batch_code}
                        onChange={(e) => setItemDetails({ ...itemDetails, supplier_batch_code: e.target.value })}
                        placeholder="Supplier Batch Code" />
                    </Col>

                  </Row>

                  <Row gutter={16}>
                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                      <Text>Expiry Date<span style={{ color: 'red' }}>*</span></Text>
                      <br />
                      <DatePicker
                        format={'DD-MM-YYYY'}
                        style={{ width: '100%' }}
                        size="large"
                        value={itemDetails?.expiry_date}
                        onChange={(date) => {
                          if (!itemDetails?.product_id) {
                            showMessage('error', 'Select a product first')
                            return;
                          }
                          if (!date) {
                            // If user clears the date
                            setItemDetails({ ...itemDetails, expiry_date: null, batch_code: '' });
                            return;
                          }
                          const DateFormat = dayjs(date).format('DD-MM-YYYY');
                          const documentNumber = 'OB';
                          const selectedProduct = products.find((item) => item?.netsuite_id == itemDetails?.product_id)
                          const batchCode = formatBatchCode(documentNumber, DateFormat, selectedProduct?.code);
                          setItemDetails({
                            ...itemDetails,
                            expiry_date: date ? dayjs(date, 'YYYY-MM-DD') : null,
                            batch_code: batchCode
                          })
                        }}
                        placeholder="Expiry Date"
                        disabledDate={(current) => {
                          return current && current < dayjs().startOf('day')
                        }}

                      />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                      <Text>Batch Code</Text>
                      <br />
                      <Input size="large" value={itemDetails?.batch_code}
                        disabled
                        placeholder="Batch Code" />
                    </Col>
                  </Row>
                  <Divider />
                  <Flex justify="end" gap={5}>
                    <Button onClick={() => handleModalCancel()}>Cancel</Button>
                    {
                      itemDetails?.product_id && (
                        <Button type="primary"
                          onClick={() => handleModalOk()}
                        >
                          Save
                        </Button>
                      )
                    }
                  </Flex>

                </>
              )
            }

          </>
          {
            batchTransactions?.length > 0 && (
              <Table
                dataSource={batchTransactions}
                columns={batchCol}
                pagination={false}
                style={{ marginTop: "10px" }}
                scroll={{ x: 'max-content' }}
                rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
              />
            )
          }
        </>
      </Modal>
    </DataSheet>
  )
}

export default TransactionsOpeningBalanceList
